import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import NuovoAssegno from "@/pages/NuovoAssegno";
import Archivio from "@/pages/Archivio";
import Scadenze from "@/pages/Scadenze";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Dashboard />} />
            <Route path="/nuovo" element={<NuovoAssegno />} />
            <Route path="/archivio" element={<Archivio />} />
            <Route path="/scadenze" element={<Scadenze />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
